module.exports = __webpack_public_path__ + "static/media/ScrollTop.80e59520.svg";